import { restClient } from '../../client';
import { TimeRange } from '@uplift/types';


export const getFinancesTimeRange = async (providerId: string) =>
  restClient.request<{
    data: TimeRange;
  }>(`/api/v1/provider/${providerId}/finances/range`);
